import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  firstPartyIntegrationListSchema,
  type ApiError,
  type FirstPartyIntegrationList,
} from '@molt/shared';
import { get } from './api';
import { queryKeys } from './query-keys';

export function getFirstPartyIntegrations(): Promise<FirstPartyIntegrationList> {
  return get('/me/first-party-integrations', firstPartyIntegrationListSchema);
}

export function getBoardFirstPartyIntegrations(
  boardId: string,
): Promise<FirstPartyIntegrationList> {
  return get(
    `/boards/${encodeURIComponent(boardId)}/first-party-integrations`,
    firstPartyIntegrationListSchema,
  );
}

export function firstPartyIntegrationsQueryOptions(enabled = true) {
  return queryOptions({
    queryKey: queryKeys.meFirstPartyIntegrations(),
    queryFn: getFirstPartyIntegrations,
    enabled,
  });
}

export function boardFirstPartyIntegrationsQueryOptions(boardId: string, enabled = true) {
  return queryOptions({
    queryKey: queryKeys.boards.firstPartyIntegrations(boardId),
    queryFn: () => getBoardFirstPartyIntegrations(boardId),
    enabled,
  });
}

export function useFirstPartyIntegrations(
  enabled = true,
): UseQueryResult<FirstPartyIntegrationList, ApiError> {
  return useQuery<FirstPartyIntegrationList, ApiError>({
    queryKey: queryKeys.meFirstPartyIntegrations(),
    queryFn: getFirstPartyIntegrations,
    enabled,
  });
}

export function useBoardFirstPartyIntegrations(
  boardId: string,
  enabled = true,
): UseQueryResult<FirstPartyIntegrationList, ApiError> {
  return useQuery<FirstPartyIntegrationList, ApiError>({
    queryKey: queryKeys.boards.firstPartyIntegrations(boardId),
    queryFn: () => getBoardFirstPartyIntegrations(boardId),
    enabled,
  });
}
